import React, { useEffect, useRef } from 'react';

import { Color } from '../../theme';
import { PageType } from '../../enums/pageType.enum';
import { Link, IconWithTwoCircles } from '../../uiComponents';
import { ButtonData } from '../../interfaces/buttonData.types';
import { renderWhenTrueOr, renderWhenTrue, renderInternalLink, renderExternalLink } from '../../utils';

import {
  Container,
  Image,
  ContentSection,
  StyledHeaderH3,
  ImageContainer,
  ColorBar,
  ContentSectionButton,
} from './imagesSectionContent.styled';
import { ImagesSectionContentData } from './imagesSectionContent.types';
import { ImagesSectionContentLayoutType } from './imagesSectionContent.enums';

export const ImagesSectionContent: React.FC<ImagesSectionContentData> = (data: ImagesSectionContentData) => {
  const {
    buttonLabel,
    image,
    icon,
    headerContent,
    layoutType,
    currentLanguage,
    positionType,
    internalPage,
    externalPage,
    imageSectionRefs,
    setRefresh,
  } = data;
  const imgRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    imageSectionRefs && imageSectionRefs.push([imgRef, contentRef]);
  }, []);

  useEffect(() => {
    if(image?.localFile?.url) {
     setRefresh && setRefresh(true);
    }
  }, [data]);

  const renderColorBar = renderWhenTrue(() => <ColorBar />);

  const renderImage = (shouldRenderColorBar: boolean) => (
    <ImageContainer ref={imgRef}>
      <Image src={image?.localFile?.url} alt={image.alt_text} />
      {renderColorBar(shouldRenderColorBar)}
    </ImageContainer>
  );

  const renderLink = renderWhenTrueOr(
    () => renderInternalLink(buttonLabel, internalPage, currentLanguage),
    () => renderExternalLink(buttonLabel, externalPage)
  );

  const renderContentSection = () => (
    <ContentSection ref={contentRef}>
      <IconWithTwoCircles
        icon={icon?.localFile?.url}
        alt={icon.alt_text}
        circleBackgroundColor={Color.yellow}
      />
      <StyledHeaderH3>{headerContent}</StyledHeaderH3>
      <ContentSectionButton>
        {renderLink(positionType === PageType.Internal)}
      </ContentSectionButton>
    </ContentSection>
  );

  const renderImageContentLayout = () => (
    <>
      {renderImage(false)}
      {renderContentSection()}
    </>
  );

  const renderContentImageLayout = () => (
    <>
      {renderContentSection()}
      {renderImage(true)}
    </>
  );

  const renderImageWithContent = renderWhenTrueOr(
    renderImageContentLayout,
    renderContentImageLayout
  );

  return (
    <Container reverseOnMobile={layoutType === ImagesSectionContentLayoutType.ContentImageLayout}>
      {renderImageWithContent(layoutType === ImagesSectionContentLayoutType.ImageContentLayout)}
    </Container>
  );
}
